{
  "v8d.workflow.approbation.one-person": "Approbation par une personne",
  "v8d.workflow.approbation.quorum": "Approbation au quorum",
  "v8d.workflow.approbation.sod": "Approbation avec séparation des tâches : un tiers approuve",
  "v8d.workflow.code.DROIT_NON_TENU": "Vous ne tenez pas le droit de voir les modèles de l’organisation.",
  "v8d.workflow.code.RESOURCE_UNAVAILABLE": "Workflow introuvable dans votre organisation.",
  "v8d.workflow.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v8d.workflow.declencheur.manual": "Déclenché à la demande",
  "v8d.workflow.declencheur.on_push": "Déclenché à chaque poussée sur le dépôt",
  "v8d.workflow.etat.chargement": "Chargement : {{quoi}}…",
  "v8d.workflow.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v8d.workflow.etat.introuvable": "Workflow introuvable dans votre organisation.",
  "v8d.workflow.etat.reessayer": "Réessayer",
  "v8d.workflow.etat.refus": "Accès refusé : {{quoi}}.",
  "v8d.workflow.etat_objet.brouillon": "Brouillon",
  "v8d.workflow.etat_objet.publie": "Publié",
  "v8d.workflow.fiche.execution": "Exécuté par l’exécuteur de la plateforme (aucun moteur de processus).",
  "v8d.workflow.fiche.libelle": "la fiche du workflow",
  "v8d.workflow.fiche.reference": "Déclaration de référence : {{porteur}}.",
  "v8d.workflow.fiche.reference_courante": "{{modele}}, configuration courante",
  "v8d.workflow.fiche.reference_version": "{{modele}}, version {{n}}",
  "v8d.workflow.fiche.titre": "Workflow — fiche",
  "v8d.workflow.fiche.variantes": "Variantes connues dans l’organisation : {{n}}. Un projet exécute celle du modèle sur lequel il est épinglé.",
  "v8d.workflow.graphe.declencheur": "{{declencheur}}.",
  "v8d.workflow.graphe.etapes": "Étapes du workflow",
  "v8d.workflow.graphe.minuteries": "Aucune minuterie : l’exécuteur de la plateforme n’en gère pas.",
  "v8d.workflow.graphe.reprises": "Reprises sur erreur : {{reprises}}.",
  "v8d.workflow.graphe.reprises_par_defaut": "(valeurs par défaut de la plateforme)",
  "v8d.workflow.graphe.titre": "Déroulé en mots",
  "v8d.workflow.instances.estimee": "Attribution estimée à la lecture : la variante d’un projet est celle de son modèle épinglé aujourd’hui ; la variante réellement exécutée n’est pas enregistrée.",
  "v8d.workflow.instances.nombre": "{{n}} en cours",
  "v8d.workflow.instances.non_nommes": "et {{n}} projets que vous ne pouvez pas lire",
  "v8d.workflow.instances.projet": "{{nom}} ({{n}})",
  "v8d.workflow.instances.titre": "Instances en cours par version",
  "v8d.workflow.instances.variante_courante": "Variante estimée {{empreinte}} — {{modele}}, configuration courante (projet non épinglé)",
  "v8d.workflow.instances.variante_inconnue": "Variante inconnue : le modèle ou sa version n’existe plus",
  "v8d.workflow.instances.variante_version": "Variante estimée {{empreinte}} — {{modele}}, version {{n}}",
  "v8d.workflow.instances.version_ancienne": "Version ancienne : ces instances finissent sur leur version.",
  "v8d.workflow.instances.vide": "Aucune instance en cours.",
  "v8d.workflow.modeles.configuration_seule": "Configuration courante seulement, aucune version publiée.",
  "v8d.workflow.modeles.titre": "Modèles qui l’emploient",
  "v8d.workflow.modeles.version_etape": "version {{n}}, étape {{etape}}",
  "v8d.workflow.modeles.version_sans_etape": "version {{n}}, aucune étape du processus ne l’automatise",
  "v8d.workflow.modeles.vide": "Aucun modèle visible n’emploie ce workflow.",
  "v8d.workflow.origine.organisation": "Créé par l’organisation",
  "v8d.workflow.origine.organisation_court": "organisation",
  "v8d.workflow.origine.plateforme": "Fourni par la plateforme, non modifiable",
  "v8d.workflow.origine.plateforme_court": "plateforme",
  "v8d.workflow.taches.droit_a_decider": "Qui la tient : rôles historiques ; droit atomique pas encore décidé.",
  "v8d.workflow.taches.ligne": "{{etape}} — {{modele}}",
  "v8d.workflow.taches.roles": "Rôles : {{roles}}",
  "v8d.workflow.taches.titre": "Tâches humaines et qui les tient",
  "v8d.workflow.taches.vide": "Aucune étape humaine n’attend ce workflow.",
  "v8d.workflow.tout_le_catalogue": "Tout le catalogue",
  "v8d.workflow.usages.libelle": "les usages du workflow",
  "v8d.workflow.versions.aucun_espace": "Utilisée par aucun espace.",
  "v8d.workflow.versions.brouillon": "Brouillon non publié",
  "v8d.workflow.versions.espaces_caches": "Utilisée par {{n}} espaces, non lisibles pour vous.",
  "v8d.workflow.versions.espaces_noms": "Utilisée par {{n}} espaces : {{noms}}.",
  "v8d.workflow.versions.espaces_noms_et_caches": "Utilisée par {{n}} espaces : {{noms}} et {{caches}} non lisibles.",
  "v8d.workflow.versions.libelle": "les versions du workflow",
  "v8d.workflow.versions.porteur_courant": "{{modele}} (configuration courante)",
  "v8d.workflow.versions.porteur_version": "{{modele}} v{{n}}",
  "v8d.workflow.versions.porteurs": "Portée par : {{porteurs}}",
  "v8d.workflow.versions.publiee": "publiée le {{date}} par {{nom}}",
  "v8d.workflow.versions.rang": "Variante {{n}}",
  "v8d.workflow.versions.sans_validation": "aucune validation enregistrée",
  "v8d.workflow.versions.titre": "Versions",
  "v8d.workflow.versions.validee": "validée par {{nom}}",
  "v8d.workflow.versions.vide": "Aucune version de ce workflow."
}
